<h2
    class="flex justify-center mat-typography"
    mat-dialog-title
    [ngClass]="{
        'text-green-600': !data.error,
        'text-red-600': data.error || data.status !== 'success'
    }"
>
    {{ data.status }}
</h2>
<mat-dialog-content class="flex justify-center mat-typography">
    {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions class="flex justify-center">
    <button
        mat-button
        (click)="closeDialog()"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    >
        close
    </button>
</mat-dialog-actions>
